import { container } from 'tsyringe';

export const baseContainer = container.createChildContainer();
export { ServiceTokens as BaseServiceTokens } from './tokens';
